import { Link } from 'react-router';

const titleMask = {
  'APC dental': 'APC',
};

/**
 * Lazy-load bread crumbs from storage
 * @param passed Passed bread crumbs
 * @param current Current bread crumbs
 * @param id Identifier unique to sending component
 */
export const getCrumbs = (passed, current, id) => {
  id += '_breadcrumbs'; // Add suffix so not to pollute sessionStorage namespace

  const generateAndSave = (passed, current, id) => {
    let crumbs = [...passed, current];
    sessionStorage.setItem(id, JSON.stringify(crumbs));
    return crumbs;
  };

  let crumbs;
  if (!passed || passed.length === 0) {
    // Only attempt to get crumbs from storage if there are none passed
    let storedCrumbs = null;
    try {
      const stored = sessionStorage.getItem(id);
      if (stored) {
        storedCrumbs = JSON.parse(stored);
      }
    } catch {
      // Invalid JSON in storage, clear it
      sessionStorage.removeItem(id);
    }
    // Validate stored crumbs: if the last crumb's URL doesn't match current URL, it's stale
    if (storedCrumbs && storedCrumbs.length > 0) {
      const lastStoredCrumb = storedCrumbs[storedCrumbs.length - 1];
      if (lastStoredCrumb && lastStoredCrumb.url && lastStoredCrumb.url === current.url) {
        crumbs = storedCrumbs;
      } else {
        // Stale breadcrumbs from a different page, clear them
        sessionStorage.removeItem(id);
        // Generate default breadcrumb trail: dashboard -> (form list if applicable) -> current page
        const defaultPassed = [{ title: 'dashboard', url: '/' }];
        // If current URL matches /form/{formType}/{formId}, infer the form list page
        // Extract pathname from URL (remove query params and hash)
        const urlPathname = current.url ? current.url.split('?')[0].split('#')[0] : '';
        const formMatch = urlPathname.match(/^\/form\/([^/]+)\/[^/]+$/);
        if (formMatch && current.title && current.title.trim()) {
          const formType = formMatch[1];
          const formListUrl = `/forms/${formType}`;
          // Use the same title as the current form (e.g., "Change my details")
          defaultPassed.push({ title: current.title.trim(), url: formListUrl });
        }
        crumbs = generateAndSave(defaultPassed, current, id);
      }
    }
  } else if (passed.filter((crumb) => JSON.stringify(crumb) === JSON.stringify(current)).length > 0) {
    crumbs = passed; // If we have already visited this node, assume we are revisiting it along the same path and don't add it
  }

  if (!crumbs) {
    // Default to generating and saving a new crumbs
    crumbs = generateAndSave(passed, current, id);
  }

  return crumbs;
};

const styleCrumb = (word) => {
  if (!word) return;
  const [head, tail] = [word[0], word.slice(1)];
  word = head.toUpperCase() + tail.toLowerCase();
  return word.replace(/apc/gi, 'APC'); // APC needs always to be capitalized
};

/**
 * Prints text bread-crumbs given a list of title/url pairs
 * @param crumbs The parts of the bread crumbs
 */
const Breadcrumbs = ({ crumbs }) =>
  !crumbs || crumbs.length < 2 ? null : (
    <div className="container">
      <div className="bread-crumbs">
        {crumbs.map(({ title, url, params }, index) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <div key={index}>
            &nbsp;
            <Link
              to={{
                pathname: url,
                search: params,
                state: { breadCrumbs: crumbs.slice(0, index) },
              }}
            >
              {titleMask[title] || styleCrumb(title)}
            </Link>
            {index + 1 === crumbs.length ? '' : '  >'}
          </div>
        ))}
      </div>
    </div>
  );

export default Breadcrumbs;
